import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';
import { Radio, RadioGroup } from "@mui/material";
import { Card, CardContent } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useMaterialReactTable } from 'material-react-table';
import ReactApexChart from "react-apexcharts";
import GavelIcon from '@mui/icons-material/Gavel';
import BuildIcon from '@mui/icons-material/Build';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'; // Viagens
import WarningAmberIcon from '@mui/icons-material/WarningAmber';   // Excesso de velocidade
import ScheduleIcon from '@mui/icons-material/Schedule';           // Fora de horário
import { 
    MaterialReactTable,

} from 'material-react-table';
import WeekendIcon from '@mui/icons-material/Weekend'; // ícone de fim de semana
import { Chip, Stack } from '@mui/material';
import CarCrashIcon from '@mui/icons-material/CarCrash';

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@material-ui/core/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { styled } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import CancelIcon from '@mui/icons-material/Cancel';
import SpeedIcon from '@mui/icons-material/Speed';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import MapRota from './MapRota';


import VizualizarRota from './vizualizarRota';
import Ocorrencias from './ocorrencias';
import CadastrarOcorrencia from './cadastrarOcorrencia';
import CadastrarAdvertencia from './cadastrarAdvertencia';
import Advertencias from './advertencias';
import CadastrarAtribuicao from './cadastrarAtribuicao';
import Atribuicoes from './atribuicoes';

import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { AddToQueueOutlined, LaptopWindows } from '@material-ui/icons';
import FormularioCadastro from './formularioCadastro'


const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'blue',
        color: 'whit',
        borderColor: 'red',
    },
}));

const WhiteTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#ffffff',
        color: '#000000',
        fontSize: 14,
        border: '1px solid #ddd',
        maxWidth: 300,
    },
}));
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
        chip: {
            fontSize: "18px",
            fontWeight: "bold",
            height: "auto", // permite aumentar a altura
            '& .MuiChip-label': {
                whiteSpace: "normal",
                wordBreak: "break-word",
                padding: "8px 8px",
                lineHeight: 1.4,
                display: "block", // sem flex restritivo
            }
        }
    },

    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));

const cardStyle = (bgColor) => ({
    padding: '10px',
    backgroundColor: bgColor,
    color: 'white',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    margin: '2px'
});

const valueStyle = {
    color: '#e0e0e0',
    fontSize: '22px',
    marginTop: '4px'
};

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'whit',
        borderColor: 'blue',
    },
}));




const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};



export default function GerenciarVeiculo() {


    const classes = useStyles();
    const history = useHistory();

    const [loading, setLoading] = useState(true);
    const [veiculo, setVeiculo] = useState();
    const { idVeiculo } = useParams();


    const hoje = new Date();

    // Estados
    const [dia, setDia] = useState('');
    const [mes, setMes] = useState(String(hoje.getMonth() + 1).padStart(2, '0'));
    const [ano, setAno] = useState(String(hoje.getFullYear()));

    // Estados
    const [diaD, setDiaD] = useState('');
    const [mesD, setMesD] = useState('');
    const [anoD, setAnoD] = useState(String(hoje.getFullYear()));

    const [novoStatus, setNovoStatus] = useState(0);

    const formatarHora = (horaArray) => horaArray.map(n => n.toString().padStart(2, '0')).join(':');

    const [atribuicao, setAtribuicao] = useState(null);

    async function listarInformacoes() {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get("/v1/protected/veiculos/listarporid/" + idVeiculo, {
                headers: headers
            }).then(function (response) {
                setVeiculo(response.data);
                console.log(JSON.stringify(response.data.rastreamentos));
                setNovoStatus(response.data.status_veiculo);


                listarDashboard();

                api.get("/v1/protected/veiculos/atribuicoes/listaremandamentoporveiculo/" + idVeiculo, {
                    headers: headers
                }).then(function (response) {
                    setAtribuicao(response.data);


                    setLoading(false);
                });

            });
        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar informações: " + _err)

        }

    }



    useEffect(() => {
        listarInformacoes();


    }, []);

    const formatTempo = (segundos) => {
        if (!segundos) return "00:00:00";
        const h = Math.floor(segundos / 3600);
        const m = Math.floor((segundos % 3600) / 60);
        const s = segundos % 60;
        return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
    };
    const dadosFiltrados = useMemo(() => {
        if (!veiculo?.rastreamentos) return [];

        return veiculo.rastreamentos
            .filter(r => {
                const [d, m, y] = r.data_inicio.split('-');
                if (mes && m !== mes) return false;
                if (ano && y !== ano) return false;
                if (dia && d !== dia) return false;
                return true;
            })
            .sort((a, b) => {
                const [d1, m1, y1] = a.data_inicio.split('-').map(Number);
                const [d2, m2, y2] = b.data_inicio.split('-').map(Number);

                const [h1, min1, s1] = a.hora_inicio.map(Number);
                const [h2, min2, s2] = b.hora_inicio.map(Number);

                const timeA = new Date(y1, m1 - 1, d1, h1, min1, s1).getTime();
                const timeB = new Date(y2, m2 - 1, d2, h2, min2, s2).getTime();

                if (timeA !== timeB) {
                    return timeA - timeB;
                }

                // Ordenação secundária por id do rastreamento
                return a.id_rastreamento - b.id_rastreamento;
            });
    }, [veiculo, dia, mes, ano]);
    /*
    
     const estatisticas = useMemo(() => {
        if (!dadosFiltrados || dadosFiltrados.length === 0) return [];
    
        const mapaFaixas = {};
        for (let h = 0; h < 24; h++) {
            mapaFaixas[h] = { numViajens: 0, altaVelocidade: 0 }; // contador
        }
    
        dadosFiltrados.forEach(r => {
            const horaInicio = r.hora_inicio[0]; // pega a hora do array
            if (horaInicio == null || horaInicio < 0 || horaInicio > 23) return;
    
            const faixa = mapaFaixas[horaInicio];
            faixa.numViajens++;
            if (r.velocidade_max > 110) {
                faixa.altaVelocidade++; // incrementa em vez de só marcar true
            }
        });
    
        const estatisticasArray = [];
        for (let h = 0; h < 24; h++) {
            estatisticasArray.push({
                hora: h,
                numViajens: mapaFaixas[h].numViajens,
                altaVelocidade: mapaFaixas[h].altaVelocidade,
            });
        }
    
        return estatisticasArray;
    }, [dadosFiltrados]);
    
    
        const dadosGrafico = useMemo(() => {
            return {
                series: [
                    { name: 'Número de Viagens', data: estatisticas.map(e => e.numViajens) },
                    { name: 'Alta Velocidade', data: estatisticas.map(e => e.altaVelocidade) },
                ],
                options: {
                    chart: { type: 'area', height: '100%', toolbar: { show: true } },
                    colors: ['#0288d1', '#d32f2f'],
                    stroke: { curve: 'smooth', width: 3 },
                    markers: { size: 5, colors: ['#0288d1', '#d32f2f'], strokeColors: '#fff', strokeWidth: 2 },
                    xaxis: { categories: estatisticas.map(e => e.hora), title: { text: 'Hora do Dia' } },
                    yaxis: [
                        { title: { text: 'Número de Viagens' } },
                        { opposite: true, title: { text: 'Alta Velocidade (0 ou 1)' } }
                    ],
                    tooltip: { shared: true },
                    dataLabels: { enabled: true },
                }
            };
        }, [estatisticas]);
    
    */

    const [coords, setCoords] = useState([]);

    useEffect(() => {
        if (dadosFiltrados && dadosFiltrados.length > 0) {
            const novasCoords = [];

            dadosFiltrados.forEach(item => {
                const inicio = {
                    lat: parseFloat(item.latitude_inicio),
                    lng: parseFloat(item.longitude_inicio)
                };
                const fim = {
                    lat: parseFloat(item.latitude_fim),
                    lng: parseFloat(item.longitude_fim)
                };

                // Adiciona somente se forem números válidos
                if (!isNaN(inicio.lat) && !isNaN(inicio.lng)) {
                    novasCoords.push(inicio);
                }
                if (!isNaN(fim.lat) && !isNaN(fim.lng)) {
                    novasCoords.push(fim);
                }
            });

            // Pega somente as 2 primeiras coordenadas
            const coordsLimitadas = novasCoords;

            console.log('coords enviadas:', coordsLimitadas);
            setCoords(coordsLimitadas);
        }
    }, [dadosFiltrados]);

    const maiorVelocidadeObj = useMemo(() => {
        if (dadosFiltrados.length === 0) return null;
        return dadosFiltrados.reduce((max, cur) =>
            cur.velocidade_max > max.velocidade_max ? cur : max
        );
    }, [dadosFiltrados]);


    const velocidadesAltas = useMemo(() => {
        return dadosFiltrados
            .filter(d => d.velocidade_max > 110)
            .sort((a, b) => b.velocidade_max - a.velocidade_max); // da maior para menor
    }, [dadosFiltrados]);


    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {

        if (newValue === 1)
            listarDashboard();
        else if (newValue === 2)
            listarAtribuicoes();
        else if (newValue === 4)
            listarOcorrencias();
        else if (newValue === 5) {
            listarOcorrencias();
            listarAdvertencias();
        }

        setValue(newValue);

    }



    const [novaAtribuicao, setNovaAtribuicao] = useState(false);

    const openNovaAtribuicao = () => {

        setNovaAtribuicao(true);

    }

    const [novaOcorrencia, setNovaOcorrencia] = useState(false);

    const openNovaOcorrencia = () => {

        setNovaOcorrencia(true);

    }


    const [ocorrencias, setOcorrencias] = useState([]);

    const [loadingOcorrencias, setLoadingOcorrencias] = useState(true);

    async function listarOcorrencias() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/veiculos/ocorrencias/listarporveiculo/" + veiculo.id_veiculo, {
                headers: headers
            }).then(function (response) {
                setOcorrencias(response.data)
                setLoadingOcorrencias(false);


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)

        }

    }

    const [atribuicoes, setAtribuicoes] = useState([]);

    const [loadingAtribuicoes, setLoadingAtribuicoes] = useState(true);

    async function listarAtribuicoes() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/veiculos/atribuicoes/listarporveiculo/" + veiculo.id_veiculo, {
                headers: headers
            }).then(function (response) {
                setAtribuicoes(response.data)
                setLoadingAtribuicoes(false);


            });


        } catch (_err) {

            console.log("Erro ao listar atribuicoes: " + _err)
            alert("Erro ao listar atribuições: " + _err);
        }

    }


    function formatarDataBR(dateObj) {
        let dia = String(dateObj.getDate()).padStart(2, '0');
        let mes = String(dateObj.getMonth() + 1).padStart(2, '0');
        let ano = dateObj.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    function returnDescricaoAtribuicao(atribuicao) {
        var dataBR = formatarDataBR(new Date(atribuicao.data_retirada));

        var texto = "Veículo encontra se em uso\n" +
            "Motorista: " + atribuicao.responsavel.nome + " " + atribuicao.responsavel.sobrenome + "\n" +
            "Data retirada: " + dataBR + " às " + atribuicao.hora_retirada;

        return texto;
    }

    const [dashboard, setDashboard] = useState(null);

    const [loadingDashboard, setLoadingDashboard] = useState(true);

    async function listarDashboard() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/veiculos/dashboard/listarporid/" + idVeiculo, {
                headers: headers
            }).then(function (response) {
                console.log(response.data);
                setDashboard(response.data)

                setLoadingDashboard(false);

            });


        } catch (_err) {

            console.log("Erro ao listar dashboard: " + _err)

        }

    }



    const closeNovaOcorrencia = () => {
        setNovaOcorrencia(false);
        listarOcorrencias();
    }


    const closeNovaAtribuicao = () => {
        setNovaAtribuicao(false);
        listarAtribuicoes();
    }








    const [novaAdvertencia, setNovaAdvertencia] = useState(false);

    const openNovaAdvertencia = () => {

        setNovaAdvertencia(true);

    }


    const [advertencias, setAdvertencias] = useState([]);

    const [loadingAdvertencias, setLoadingAdvertencias] = useState(true);

    async function listarAdvertencias() {


        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/veiculos/advertencias/listarporveiculo/" + veiculo.id_veiculo, {
                headers: headers
            }).then(function (response) {
                setAdvertencias(response.data)
                setLoadingAdvertencias(false);


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)

        }

    }


    const closeNovaAdvertencia = () => {
        setNovaAdvertencia(false);
        listarAdvertencias();
    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };

    // Função auxiliar para converter segundos em hh:mm:ss
    const formatarTempo = (segundos) => {
        const h = Math.floor(segundos / 3600).toString().padStart(2, '0');
        const m = Math.floor((segundos % 3600) / 60).toString().padStart(2, '0');
        const s = Math.floor(segundos % 60).toString().padStart(2, '0');
        return `${h}:${m}:${s}`;
    };


    const totais = useMemo(() => {

        const num_viajens = dadosFiltrados.length;

        const litros = dadosFiltrados.reduce((acc, r) => acc + r.litros, 0);
        const custo = dadosFiltrados.reduce((acc, r) => acc + r.custo, 0);
        const tempo = dadosFiltrados.reduce((acc, r) => acc + r.tempo, 0);
        const km = dadosFiltrados.reduce((acc, r) => acc + r.km, 0);
        const odometro = dadosFiltrados.reduce(
            (acc, r) => acc + (r.odometro_fim - r.odometro_inicio),
            0
        );

        // contadores de avisos
        const excessos_velocidades = dadosFiltrados.reduce((acc, r) => acc + (r.alta_velocidade === 1 ? 1 : 0), 0);
        const fins_semana = dadosFiltrados.reduce((acc, r) => acc + (r.fim_semana === 1 ? 1 : 0), 0);
        const fora_horarios = dadosFiltrados.reduce((acc, r) => acc + (r.fora_horario === 1 ? 1 : 0), 0);

        return { litros, custo, tempo, km, odometro, excessos_velocidades, fins_semana, fora_horarios, num_viajens };
    }, [dadosFiltrados]);

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }




    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };


    function returnDescricaoUsuario(usuario) {
        var texto = usuario.nome_amigavel;


        return texto;
    }


    const calcPercent = (valor) => {
        if (!totais.num_viajens) return 0;
        return ((valor / totais.num_viajens) * 100).toFixed(1);
    };


    async function handleClickMudarStatus() {


        try {
            const cadastro = {};
            const headers = { 'Authorization': 'Bearer ' + Cookies.get("token") };
            const url = "/v1/protected/veiculos/mudarStatus/" + Cookies.get("id_usuario") + "/" + veiculo.id_veiculo + "/" + novoStatus;
            const response = await api.put(url, { headers }); // <-- Aqui está o ajuste


            if (response.data) {
                alert("Status do Veículo modificado!");
                listarInformacoes();

            } else {
                alert("Erro ao Mudar Status do Veiculo!");
                return;
            }

        } catch (error) {
            alert("Erro ao Mudar Status do Veiculo!" + error);
            return;
        }
    }





    const columns = useMemo(
        () => [



            {
                accessorKey: 'id_rastreamento', //normal accessorKey
                header: 'ID',
                size: 60,
            },
            {
                accessorKey: 'data_inicio', //normal accessorKey
                header: 'Data',
                size: 80,
            },

            {
                header: 'Avisos',
                size: 80,
                accessorFn: (row) => row, // pegamos a linha inteira
                Cell: ({ row }) => {
                    const { alta_velocidade, fora_horario, fim_semana } = row.original;

                    return (
                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            {alta_velocidade === 1 && (
                                <SpeedIcon style={{ color: 'red' }} titleAccess="Excesso de Velocidade" />
                            )}
                            {fora_horario === 1 && (
                                <AccessTimeIcon style={{ color: 'orange' }} titleAccess="Fora do Horário Limite" />
                            )}
                            {fim_semana === 1 && (
                                <WeekendIcon style={{ color: 'blue' }} titleAccess="Viagem no Fim de Semana" />
                            )}
                        </div>
                    );
                },
                muiTableBodyCellProps: {
                    sx: {
                        justifyContent: 'center',
                    }
                }
            },
            {
                header: 'Viagem',
                size: 350, // reduzindo tamanho base
                accessorKey: 'viagem',
                Cell: ({ cell }) => {
                    const valor = cell.getValue() || '';
                    return (
                        <div style={{
                            whiteSpace: 'normal',
                            lineHeight: '1.3em',
                            fontSize: '0.85rem', // fonte menor
                            wordBreak: 'break-word'
                        }}>
                            {valor.split('|').map((parte, index) => (
                                <div key={index}>{parte.trim()}</div>
                            ))}
                        </div>
                    );
                },
                muiTableBodyCellProps: {
                    sx: {
                        whiteSpace: 'normal',
                        lineHeight: '1.3em',
                        padding: '6px',
                        fontSize: '0.85rem',
                    }
                }
            },

            {
                header: 'Análise',
                size: 400,
                accessorFn: (row) => row, // passamos a linha inteira para o Cell
                Cell: ({ row }) => {
                    const { alta_velocidade, fora_horario, mensagem_excesso_velocidade, mensagem_fora_horario } = row.original;

                    const mensagens = [];
                    if (alta_velocidade === 1 && mensagem_excesso_velocidade) {
                        mensagens.push(mensagem_excesso_velocidade);
                    }
                    if (fora_horario === 1 && mensagem_fora_horario) {
                        mensagens.push(mensagem_fora_horario);
                    }

                    // Se não houver mensagens, retorna vazio
                    if (mensagens.length === 0) return null;

                    return (
                        <div style={{ color: 'red', whiteSpace: 'normal', lineHeight: '1.4em' }}>
                            {mensagens.map((msg, i) => (
                                <div key={i}>{msg}</div>
                            ))}
                        </div>
                    );
                },
                muiTableBodyCellProps: {
                    sx: {
                        whiteSpace: 'normal',
                        padding: '8px',
                        lineHeight: '1.4em',
                    }
                }
            },


        ],
        [],
    );


    const table = useMaterialReactTable({
        columns: columns,
        data: dadosFiltrados,
        enableGlobalFilterModes: true,
        enablePagination: true,
        enableRowActions: true,
        paginationDisplayMode: 'pages',
        getRowId: (row) => row.id_rastreamento,
        enableTopToolbar: true,
        enableBottomToolbar: true,
        enableColumnFilters: true,
        enableColumnActions: false,
        sortable: true,
        enableSorting: true,
        enableRowSelection: false,
        enableColumnFilterModes: true,
        enableExpandAll: true,
        enableColumnPinning: true,
        enableColumnResizing: true,
        initialState: {
            pagination: { pageSize: 10000, pageIndex: 0 },
            showGlobalFilter: true,
            density: 'compact',
        },
        muiPaginationProps: {
            rowsPerPageOptions: [10000, 20000, 30000],
            variant: 'outlined',
        },
        muiTableBodyProps: {
            sx: {
                '& tr': {
                    height: 'auto', // altura automática
                }
            }
        },
        enableFullScreenToggle: true,
        renderDetailPanel: ({ row }) => (
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-around',
                    left: '30px',
                    maxWidth: '1000px',
                    position: 'sticky',
                    width: '100%',
                }}
            />
        ),


    });


    return (
        <div>
            <NavegadorGestao
                Operacional={true}
                Veiculos={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />
            <div style={{ paddingTop: 5 }} >
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :
                    <Grid
                        item xs={12}
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent={"center"}
                    >


                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            align="flex-start"
                            item xs={12}
                            style={{ width: '100%', margin: 0, padding: 0 }}
                        >

                            <a href="/gestao/operacional/frota/veiculos/listar" style={{ fontSize: 14, color: 'black', marginRight: '5px' }}>{"< Veículos | "}</a>
                            <a href={"/gestao/operacional/frota/veiculos/gerenciar/" + idVeiculo} style={{ fontSize: 14, color: 'black', marginRight: '5px' }}>{"Veículo Placa " + veiculo.placa}</a>

                        </Grid>

                        <Grid
                            item xs={12}
                            container
                            direction="row"
                            alignItems="center"
                            justifyContent={"center"}
                            style={{ marginRight: 10, marginLeft: 10 }}
                        >


                            <Box style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}>
                                <AppBar position="static" >

                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs example"


                                    >
                                        <Tab label="Informações" style={{ backgroundColor: '#1C1C1C' }} />
                                        <Tab label="Dashboard" style={{ backgroundColor: '#1C1C1C' }} />
                                        <Tab label="Atribuições" style={{ backgroundColor: '#1C1C1C' }} />
                                        <Tab label="Rastreamento" style={{ backgroundColor: '#1C1C1C' }} />
                                        <Tab label="Ocorrências" style={{ backgroundColor: '#1C1C1C' }} />
                                        <Tab label="Advertências" style={{ backgroundColor: '#1C1C1C' }} />

                                    </Tabs>
                                </AppBar>

                            </Box>
                        </Grid>

                        <SwipeableViews
                            index={value}
                            onChangeIndex={handleChangeIndex}
                            style={{ backgroundColor: 'white', width: '100%', alignItems: 'center', }}
                        >

                            <Grid
                                value={value} index={0}
                                style={{ padding: 1 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >

                                < FormularioCadastro atribuicao={atribuicao} flag={1} veiculo={veiculo} listarInformacoes={listarInformacoes} />


                            </Grid>
                            <Grid
                                value={value} index={1}
                                style={{ padding: 1 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >



                                <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                    spacing={2}
                                    item xs={12}
                                >

                                    <Grid
                                        container
                                        item xs={6}
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="center"
                                    >

                                        {
                                            atribuicao ?
                                                <Card
                                                    sx={{
                                                        border: "1px solid #ddd",      // borda cinza clara
                                                        borderRadius: "8px",           // cantos arredondados
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // sombra suave
                                                        padding: "12px",
                                                        marginBottom: "16px",
                                                        backgroundColor: "#fff"
                                                    }}
                                                >
                                                    <CardContent sx={{ padding: "8px !important" }}>
                                                        <Typography
                                                            variant="body1"
                                                            color="text.primary"
                                                            sx={{ whiteSpace: "pre-line" }}
                                                        >
                                                            {returnDescricaoAtribuicao(atribuicao)}
                                                        </Typography>
                                                    </CardContent>
                                                </Card>
                                                :
                                                <Card
                                                    sx={{
                                                        border: "1px solid #ddd",      // borda cinza clara
                                                        borderRadius: "8px",           // cantos arredondados
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // sombra suave
                                                        padding: "12px",
                                                        marginBottom: "16px",
                                                        backgroundColor: "#fff"
                                                    }}
                                                >
                                                    <CardContent sx={{ padding: "8px !important" }}>
                                                        <Typography
                                                            variant="body1"
                                                            color="text.primary"
                                                            sx={{ whiteSpace: "pre-line" }}
                                                        >
                                                            {"Veículo Ocioso"}
                                                        </Typography>
                                                    </CardContent>
                                                </Card>

                                        }

                                    </Grid>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={6}
                                        styke={{ paddingTop: '10px' }}
                                    >
                                        <span
                                            style={{
                                                padding: "5px 10px",
                                                borderRadius: "5px",
                                                fontWeight: "bold",
                                                display: "inline-block",
                                                minWidth: "120px",
                                                textAlign: "center",
                                                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                                                color:
                                                    veiculo.status_veiculo === 2 ? "#000" : "#fff", // Preto no amarelo
                                                backgroundColor:
                                                    veiculo.status_veiculo === 0 ? "#4CAF50" : // verde
                                                        veiculo.status_veiculo === 1 ? "#F44336" : // vermelho
                                                            veiculo.status_veiculo === 2 ? "#FFEB3B" : // amarelo
                                                                veiculo.status_veiculo === 3 ? "#2196F3" : // azul
                                                                    "#ccc" // padrão
                                            }}
                                        >
                                            {veiculo.status_veiculo === 0 && "APTO"}
                                            {veiculo.status_veiculo === 1 && "INABILITADO"}
                                            {veiculo.status_veiculo === 2 && "EM MANUTENÇÃO"}
                                            {veiculo.status_veiculo === 3 && "IRREGULAR"}
                                        </span>

                                        <FormControl size="small" style={{ minWidth: 180 }}>
                                            <InputLabel>Novo Status</InputLabel>
                                            <Select
                                                value={novoStatus}
                                                onChange={(e) => setNovoStatus(e.target.value)}
                                            >
                                                <MenuItem value={0}>APTO</MenuItem>
                                                <MenuItem value={1}>INABILITADO</MenuItem>
                                                <MenuItem value={2}>EM MANUTENÇÃO</MenuItem>
                                                <MenuItem value={3}>IRREGULAR</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) => handleClickMudarStatus()}
                                            startIcon={<SwapHorizIcon />}
                                            style={{ margin: 10 }}
                                        >
                                        </Button>


                                    </Grid>
                                </Grid>

                                {!loadingDashboard
                                    &&
                                    (<Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        item xs={12}
                                    >

                                        <Grid item xs={4} style={cardStyle('#1976d2')}>
                                            <DirectionsCarIcon />
                                            <span style={{ fontWeight: 'bold' }}>Viagens</span>
                                            <Typography style={valueStyle}>
                                                {dashboard.numviagens ?? 0} viagens
                                            </Typography>
                                        </Grid>

                                        {/* Total Km */}
                                        <Grid item xs={4} style={cardStyle('#008B8B')}>
                                            <SpeedIcon />
                                            <span style={{ fontWeight: 'bold' }}>Total Km</span>
                                            <Typography style={valueStyle}>
                                                {(dashboard.totalkm ?? 0).toLocaleString('pt-BR')} km
                                            </Typography>
                                        </Grid>

                                        {/* Tempo Total */}
                                        <Grid item xs={4} style={cardStyle('#673ab7')}>
                                            <AccessTimeIcon />
                                            <span style={{ fontWeight: 'bold' }}>Tempo</span>
                                            <Typography style={valueStyle}>
                                                {formatTempo(dashboard.totaltempo)}
                                            </Typography>
                                        </Grid>

                                        {/* Excesso de Velocidade */}
                                        <Grid item xs={4} style={cardStyle('#d32f2f')}>
                                            <WarningAmberIcon />
                                            <span style={{ fontWeight: 'bold' }}>Excessos Velocidade</span>
                                            <Typography style={valueStyle}>
                                                {dashboard.excessosvelocidade ?? 0}
                                            </Typography>
                                        </Grid>

                                        {/* Fora do Horário */}
                                        <Grid item xs={4} style={cardStyle('#ff9800')}>
                                            <ScheduleIcon />
                                            <span style={{ fontWeight: 'bold' }}>Fora do Horário</span>
                                            <Typography style={valueStyle}>
                                                {dashboard.forahorario ?? 0}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={4}
                                            style={{
                                                padding: '10px',
                                                backgroundColor: '#008B8B',
                                                color: 'white',
                                                borderRadius: '8px',
                                                textAlign: 'center',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                margin: '2px'
                                            }}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <GavelIcon />
                                            <span style={{ fontWeight: 'bold' }}>
                                                Multas
                                            </span>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center', // Centraliza horizontalmente
                                                    marginTop: '2px',
                                                    alignItems: 'center',
                                                    gap: '8px' // Espaço entre os elementos
                                                }}
                                            >
                                                <Typography style={{ color: '#e0e0e0', fontSize: '26px' }}>
                                                    {dashboard.qtdmultas} multas
                                                </Typography>

                                                <Box style={{ display: 'flex', alignItems: 'center', fontSize: '32px' }}>
                                                    {(dashboard.valormultas ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                </Box>
                                            </Box>
                                        </Grid>

                                        <Grid item xs={4}
                                            style={{
                                                padding: '10px',
                                                backgroundColor: '#250a85ff',
                                                color: 'white',
                                                borderRadius: '8px',
                                                textAlign: 'center',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                margin: '2px'
                                            }}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <BuildIcon />
                                            <span style={{ fontWeight: 'bold' }}>
                                                Manutenções
                                            </span>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center', // Centraliza horizontalmente
                                                    marginTop: '2px',
                                                    alignItems: 'center',
                                                    gap: '8px' // Espaço entre os elementos
                                                }}
                                            >
                                                <Typography style={{ color: '#e0e0e0', fontSize: '26px' }}>
                                                    {dashboard.qtdmanutencoes} manutenções
                                                </Typography>

                                                <Box style={{ display: 'flex', alignItems: 'center', fontSize: '32px' }}>
                                                    {(dashboard.valormanutencoes ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                </Box>
                                            </Box>
                                        </Grid>



                                        <Grid item xs={4}
                                            style={{
                                                padding: '10px',
                                                backgroundColor: '#105270ff',
                                                color: 'white',
                                                borderRadius: '8px',
                                                textAlign: 'center',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                margin: '2px'
                                            }}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <CarCrashIcon />
                                            <span style={{ fontWeight: 'bold' }}>
                                                Acidentes
                                            </span>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center', // Centraliza horizontalmente
                                                    marginTop: '2px',
                                                    alignItems: 'center',
                                                    gap: '8px' // Espaço entre os elementos
                                                }}
                                            >
                                                <Typography style={{ color: '#e0e0e0', fontSize: '26px' }}>
                                                    {dashboard.qtdacidentes} acidentes
                                                </Typography>

                                                <Box style={{ display: 'flex', alignItems: 'center', fontSize: '32px' }}>
                                                    {(dashboard.valoracidentes ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                </Box>
                                            </Box>
                                        </Grid>


                                    </Grid>)
                                }


                            </Grid>
                            <Grid
                                value={value} index={2}
                                style={{ paddingTop: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={12}
                                >
                                    <Button style={{ margin: 5 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={openNovaAtribuicao}
                                    >
                                        Nova Atribuição
                                    </Button>
                                </Grid>
                                {!loadingAtribuicoes &&
                                    <Atribuicoes veiculo={veiculo} atribuicoes={atribuicoes} listarAtribuicoes={listarAtribuicoes} />
                                }

                            </Grid>

                            <Grid
                                value={value} index={3}
                                style={{ paddingTop: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >

                                <Grid spacing={1} item xs={12} container
                                    direction="row" justifyContent="center">
                                    <Grid item xs={5} style={{ height: "400px", width: '500px' }}>
                                        {coords.length > 0 && (
                                            <MapRota coords={coords} />
                                        )}
                                    </Grid>

                                    {/* Grid do card de maior velocidade */}
                                    {velocidadesAltas &&
                                        <Grid item xs={3} style={{ margin: '5px', maxHeight: 400, overflowY: 'auto' }}>
                                            {velocidadesAltas.map((v, index) => (
                                                <WhiteTooltip
                                                    key={index}
                                                    title={
                                                        <Box sx={{ p: 2, color: 'black' }}>
                                                            <Typography variant="subtitle2"><strong>Início:</strong> {v.data_inicio} {formatarHora(v.hora_inicio)}</Typography>
                                                            <Typography variant="subtitle2"><strong>Fim:</strong> {v.data_fim} {formatarHora(v.hora_fim)}</Typography>
                                                            <Typography variant="subtitle2"><strong>Início:</strong> {v.endereco_inicio}</Typography>
                                                            <Typography variant="subtitle2"><strong>Fim:</strong> {v.endereco_fim}</Typography>
                                                            <Typography variant="subtitle2"><strong>Km:</strong> {v.km}</Typography>
                                                            <Typography variant="subtitle2"><strong>Velocidade Máx:</strong> {v.velocidade_max} km/h</Typography>
                                                            <Typography variant="subtitle2"><strong>Tempo (s):</strong> {v.tempo}</Typography>
                                                            <Typography variant="subtitle2"><strong>Odômetro Início:</strong> {v.odometro_inicio}</Typography>
                                                            <Typography variant="subtitle2"><strong>Odômetro Fim:</strong> {v.odometro_fim}</Typography>
                                                            <Typography variant="subtitle2"><strong>Litros:</strong> {v.litros}</Typography>
                                                            <Typography variant="subtitle2"><strong>Custo:</strong> {v.custo}</Typography>
                                                        </Box>
                                                    }
                                                    placement="left"
                                                    arrow
                                                    PopperProps={{
                                                        modifiers: [
                                                            {
                                                                name: 'offset',
                                                                options: { offset: [0, 10] },
                                                            },
                                                        ],
                                                    }}
                                                >
                                                    <Card
                                                        sx={{
                                                            boxShadow: 6,
                                                            cursor: 'pointer',
                                                            borderRadius: 2,
                                                            bgcolor: '#f5f5f5',
                                                            mb: 1, // espaço entre os cards
                                                            '&:hover': { boxShadow: 12 },
                                                        }}
                                                    >
                                                        <CardContent>
                                                            <Box display="flex" flexDirection="column" alignItems="center">
                                                                <Typography variant="h6">{v.velocidade_max} km/h</Typography>
                                                                <Typography variant="subtitle2" color="textSecondary">
                                                                    Velocidade Máxima em {v.data_inicio}
                                                                </Typography>
                                                            </Box>
                                                        </CardContent>
                                                    </Card>
                                                </WhiteTooltip>
                                            ))}
                                        </Grid>
                                    }

                                    {totais &&
                                        <Grid justifyContent="center" item xs={3}>
                                            <Grid item xs={12}>
                                                <Card sx={{ bgcolor: 'white', boxShadow: 3, borderRadius: 2 }}>
                                                    <CardContent>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1.5, bgcolor: '#f9f9f9', borderRadius: 2 }}>

                                                            {/* Título */}
                                                            <Typography variant="h6" color="primary" sx={{ mb: 1 }}>📊 Resumo das Viagens</Typography>

                                                            {/* Totais gerais: um por linha */}
                                                            <Typography variant="subtitle1">🛣️ <strong>{totais.num_viajens.toFixed(0)}</strong> viagens registradas</Typography>
                                                            <Typography variant="subtitle1">⛽ <strong>{totais.litros.toFixed(2)}</strong> litros</Typography>
                                                            <Typography variant="subtitle1">💰 <strong>R$ {totais.custo.toFixed(2)}</strong></Typography>
                                                            <Typography variant="subtitle1">⏱️ <strong>{formatarTempo(totais.tempo)}</strong> tempo total</Typography>
                                                            <Typography variant="subtitle1">📏 <strong>{totais.km.toFixed(2)}</strong> km</Typography>
                                                            <Typography variant="subtitle1">🧭 <strong>{totais.odometro.toFixed(2)}</strong> odômetro</Typography>

                                                            {/* Eventos especiais */}
                                                            <Box sx={{ mt: 2 }}>
                                                                <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 0.5 }}>🚨 Eventos Especiais:</Typography>

                                                                <Stack direction="column" spacing={1}>
                                                                    <Paper
                                                                        elevation={2}
                                                                        style={{ padding: "12px", backgroundColor: "#f8d7da" }} // vermelho leve
                                                                    >
                                                                        <Typography variant="body1" style={{ fontWeight: "bold", fontSize: "14px" }}>
                                                                            ⚡ {totais.excessos_velocidades} viagens com excesso de velocidade ({calcPercent(totais.excessos_velocidades)}%)
                                                                        </Typography>
                                                                    </Paper>

                                                                    <Paper
                                                                        elevation={2}
                                                                        style={{ padding: "12px", backgroundColor: "#fff3cd" }} // amarelo leve
                                                                    >
                                                                        <Typography variant="body1" style={{ fontWeight: "bold", fontSize: "14px" }}>
                                                                            ⏰ {totais.fora_horarios} viagens fora de horário ({calcPercent(totais.fora_horarios)}%)
                                                                        </Typography>
                                                                    </Paper>

                                                                    <Paper
                                                                        elevation={2}
                                                                        style={{ padding: "12px", backgroundColor: "#d1ecf1" }} // azul leve
                                                                    >
                                                                        <Typography variant="body1" style={{ fontWeight: "bold", fontSize: "14px" }}>
                                                                            📅 {totais.fins_semana} viagens em fins de semana ({calcPercent(totais.fins_semana)}%)
                                                                        </Typography>
                                                                    </Paper>
                                                                </Stack>
                                                            </Box>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </Grid>
                                    }


                                </Grid>

                                {  /* <Grid item xs={12} style={{ padding: 10 }}>
                                    <ReactApexChart
                                        options={dadosGrafico.options}
                                        series={dadosGrafico.series}
                                        type="area"
                                        height={350}
                                    />
                                </Grid>
*/}

                                {/* Filtros centralizados */}
                                <Grid container spacing={2} justifyContent="center" sx={{ mb: 2 }}>
                                    <Grid item xs={3}>
                                        <TextField
                                            label="Dia"
                                            value={dia}
                                            onChange={e => setDia(e.target.value)}
                                            inputProps={{ maxLength: 2 }}
                                            fullWidth
                                            onBlur={() => {
                                                // Quando o usuário sair do campo, adiciona o 0 à esquerda se precisar
                                                if (dia.length === 1) setDia(dia.padStart(2, '0'));
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            label="Mês"
                                            value={mes}
                                            onChange={e => setMes(e.target.value)}
                                            inputProps={{ maxLength: 2 }}
                                            fullWidth
                                            onBlur={() => {
                                                // Quando o usuário sair do campo, adiciona o 0 à esquerda se precisar
                                                if (mes.length === 1) setMes(mes.padStart(2, '0'));
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <TextField
                                            label="Ano"
                                            value={ano}
                                            onChange={e => setAno(e.target.value)}
                                            inputProps={{ maxLength: 4 }}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>

                                <div style={{ overflowX: 'auto', maxWidth: '100%' }}>

                                    <div  >
                                        {
                                            veiculo.rastreamentos && (
                                                <>
                                                    <MaterialReactTable
                                                        table={table}
                                                    />



                                                </>
                                            )
                                        }
                                    </div>
                                </div>


                            </Grid>


                            <Grid
                                value={value} index={4}
                                style={{ padding: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={12}
                                >
                                    <Button style={{ margin: 5 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={openNovaOcorrencia}
                                    >
                                        Nova Ocorrência
                                    </Button>
                                </Grid>
                                {!loadingOcorrencias &&
                                    <Ocorrencias veiculo={veiculo} ocorrencias={ocorrencias} />
                                }



                            </Grid>



                            <Grid
                                value={value} index={5}
                                style={{ padding: 10 }}
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={12}
                                >
                                    <Button style={{ margin: 5 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={openNovaAdvertencia}
                                    >
                                        Nova Advertência
                                    </Button>
                                </Grid>
                                {!loadingAdvertencias &&
                                    <Advertencias veiculo={veiculo} advertencias={advertencias} ocorrencias={ocorrencias} listarAdvertencias={listarAdvertencias}/>
                                }



                            </Grid>


                        </SwipeableViews>



                    </Grid>
                }


            </div>



            <Dialog open={novaOcorrencia} onClose={closeNovaOcorrencia} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px' } }}>
                <DialogContent>
                    <CadastrarOcorrencia
                        flag={0}
                        veiculo={veiculo}
                        closeNovaOcorrencia={closeNovaOcorrencia}
                    />
                </DialogContent>
            </Dialog>


            <Dialog open={novaAdvertencia} onClose={closeNovaAdvertencia} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px' } }}>
                <DialogContent>
                    <CadastrarAdvertencia
                        flag={0}
                        veiculo={veiculo}
                        closeNovaAdvertencia={closeNovaAdvertencia}
                        ocorrencias={ocorrencias}
                        listarAdvertencias={listarAdvertencias}
                    />
                </DialogContent>
            </Dialog>


            <Dialog open={novaAtribuicao} onClose={closeNovaAtribuicao} PaperProps={{ style: { maxWidth: '1000px', minWidth: '800px' } }}>
                <DialogContent>
                    <CadastrarAtribuicao
                        flag={0}
                        veiculo={veiculo}
                        closeNovaAtribuicao={closeNovaAtribuicao}
                    />
                </DialogContent>
            </Dialog>



        </div >
    );
}


